import React from 'react';
import { FiMenu } from 'react-icons/fi';
import CompanySelector from '../company/CompanySelector';

export interface HeaderProps {
  onToggleSidebar?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-3 sm:px-4 py-3">
      <div className="flex items-center justify-between">
        {/* Botón de menú (solo visible en móvil) */}
        <button
          onClick={onToggleSidebar}
          className="lg:hidden flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-lg hover:bg-gray-100 transition-colors"
        >
          <FiMenu className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
        </button>

        {/* Título de la página (opcional) */}
        <div className="flex-1 lg:flex-none">
          {/* Este espacio se puede usar para el título de la página actual */}
        </div>

        {/* Selector de empresa en la parte derecha */}
        <div className="flex items-center">
          <CompanySelector />
        </div>
      </div>
    </header>
  );
};

export default Header;
